export enum CatalogProductsTestIds {
  PRODUCT_CARD = 'catalog-product-card',
  PRODUCT_ADD_BUTTON = 'catalog-product-add-button',
  PRODUCT_IMAGE = 'catalog-product-image',
  PRODUCT_NAME = 'catalog-product-name',
  PRODUCT_CODE = 'catalog-product-code',
  PRODUCT_PRICE = 'catalog-product-price',
  PRODUCT_CHECKBOX = 'catalog-product-checkbox',
  PRODUCT_LOCK_BUTTON = 'catalog-product-lock-button',
  COMBINATION_CHIP = 'catalog-combination-chip',
  COMBINATION_MORE_BUTTON = 'catalog-combination-more-button',
  COMBINATION_MORE_ITEM = 'catalog-combination-more-item',

  SECTION_TABS = 'catalog-section-tabs',
  SECTION_TAB = 'catalog-section-tab',
  SECTION_TABS_ADD_BUTTON = 'catalog-section-tabs-add-button',
  SECTION_TABS_MORE_BUTTON = 'catalog-section-tabs-more-button',
  SECTIONS_DROPDOWN = 'catalog-sections-dropdown',
  SECTIONS_DROPDOWN_ROW = 'catalog-sections-dropdown-row',
  SECTIONS_DROPDOWN_ROW_NAME = 'catalog-sections-dropdown-row-name',
  SECTIONS_DROPDOWN_ROW_INPUT = 'catalog-sections-dropdown-row-input',
  SECTIONS_DROPDOWN_ROW_ACTIONS = 'catalog-sections-dropdown-row-actions',
  SECTIONS_DROPDOWN_ROW_GRIP = 'catalog-sections-dropdown-row-grip',
  SECTIONS_DROPDOWN_CREATE_ROW = 'catalog-sections-dropdown-create-row',
  SECTIONS_DROPDOWN_CREATE_INPUT = 'catalog-sections-dropdown-create-input',
  SECTIONS_DROPDOWN_CREATE_CONFIRM = 'catalog-sections-dropdown-create-confirm',
  SECTIONS_DROPDOWN_LIST = 'catalog-sections-dropdown-list',
  SECTIONS_DROPDOWN_COUNT = 'catalog-sections-dropdown-count',
  SECTIONS_DROPDOWN_ROW_EDIT = 'catalog-sections-dropdown-row-edit',
  SECTIONS_DROPDOWN_ROW_DELETE = 'catalog-sections-dropdown-row-delete',
  SECTIONS_DROPDOWN_APPLY_BUTTON = 'catalog-sections-dropdown-apply-button',
  SECTIONS_DROPDOWN_DELETE_CONFIRM = 'catalog-sections-dropdown-delete-confirm',
  SECTION_TITLE = 'catalog-section-title',
  SECTION_SORT_BUTTON = 'catalog-section-sort-button',

  FILTER_SEARCH = 'catalog-filter-search',
  FILTER_COLOR = 'catalog-filter-color',
  FILTER_SIZE = 'catalog-filter-size',
  FILTER_CATEGORY = 'catalog-filter-category',
  FILTER_COLLECTION = 'catalog-filter-collection',
  FILTER_AVAILABILITY = 'catalog-filter-availability',

  MANAGE_SECTIONS_BUTTON = 'catalog-manage-sections-button',
  SHARE_BUTTON = 'catalog-share-button',

  LIVE_SHOP_BUTTON = 'catalog-live-shop-button',
  LIVE_SHOP_PANEL = 'catalog-live-shop-panel',

  DETAILS_BUTTON = 'catalog-details-button',
  DETAILS_PANEL = 'catalog-details-panel',
  DETAILS_GENERAL_DATA_NAME = 'catalog-details-general-data-name',
  DETAILS_GENERAL_DATA_CODE = 'catalog-details-general-data-code',
  DETAILS_GENERAL_DATA_LIVE_LINK = 'catalog-details-general-data-live-link',
  DETAILS_GENERAL_DATA_START_DATE = 'catalog-details-general-data-start-date',
  DETAILS_GENERAL_DATA_END_DATE = 'catalog-details-general-data-end-date',
  DETAILS_GENERAL_DATA_PUBLIC_SHARING = 'catalog-details-general-data-public-sharing',
  DETAILS_GENERAL_DATA_STATUS = 'catalog-details-general-data-status',
  DETAILS_GENERAL_DATA_MENU = 'catalog-details-general-data-menu',
  DETAILS_MANAGE_BANNERS = 'catalog-details-manage-banners',
  BANNERS_MODAL = 'catalog-banners-modal',
  BANNER = 'catalog-banner',
  BANNER_EDIT = 'catalog-banner-edit',
  DETAILS_STOCK_MIN_TOTAL_PIECES = 'catalog-details-stock-min-total-pieces',
  DETAILS_STOCK_MIN_SEQUENTIAL_SIZES = 'catalog-details-stock-min-sequential-sizes',
  DETAILS_DISPLAY_COLOR_MODE = 'catalog-details-display-color-mode',
  DETAILS_DISPLAY_UNAVAILABLE_PRODUCTS = 'catalog-details-display-unavailable-products',
  DETAILS_DISPLAY_PRODUCT_COLOR_CARDS = 'catalog-details-display-product-color-cards',
  DETAILS_DISPLAY_PRODUCT_WITHOUT_MEDIA = 'catalog-details-display-product-without-media',
  DETAILS_DISPLAY_RELATED_PRODUCTS = 'catalog-details-display-related-products',
  DETAILS_NAVIGATION_AVAILABILITIES = 'catalog-details-navigation-availabilities',
  DETAILS_NAVIGATION_DELIVERY_WINDOWS = 'catalog-details-navigation-delivery-windows',
  DETAILS_CRITERIA_ADD = 'catalog-details-criteria-add',
  DETAILS_SYNC = 'catalog-details-sync',
  DETAILS_ACCESS_SECTION = 'catalog-details-access-section',
  DETAILS_ACCESS_EDIT = 'catalog-details-access-edit',
  DETAILS_ACCESS_SHOW_MORE = 'catalog-details-access-show-more',
  DETAILS_ACCESS_TAB_PREFIX = 'catalog-details-access-tab-',
  DETAILS_ACCESS_EDIT_MODAL = 'catalog-details-access-edit-modal',
  DETAILS_ACCESS_APPLY = 'catalog-details-access-apply',
  DETAILS_ACCESS_CANCEL = 'catalog-details-access-cancel',
  DETAILS_ACCESS_MASS_ACTIONS_BAR = 'catalog-details-access-mass-actions-bar',
  DETAILS_ACCESS_CHANGE_DATES_MODAL = 'catalog-details-access-change-dates-modal',
  DETAILS_ACCESS_CHANGE_DATES_CONFIRM = 'catalog-details-access-change-dates-confirm',

  SELECT_ALL_CHECKBOX = 'catalog-select-all-checkbox',
  MASS_ACTIONS_BAR = 'catalog-mass-actions-bar',
  MOVE_TO_SECTION_MODAL = 'catalog-move-to-section-modal',
  MOVE_TO_SECTION_CONFIRM = 'catalog-move-to-section-confirm',
  MOVE_TO_SECTION_CREATE_INPUT = 'catalog-move-to-section-create-input',
  MOVE_TO_SECTION_CREATE_CONFIRM = 'catalog-move-to-section-create-confirm',
  MOVE_TO_SECTION_NEW_CHIP = 'catalog-move-to-section-new-chip',

  SCREEN_LOADING = 'catalog-products-screen-loading',
  LIST_V2 = 'catalog-products-list-v2',
  LIST_ERROR = 'catalog-list-error',
  EMPTY_STATE = 'catalog-empty-state',
  EMPTY_SLOT = 'catalog-empty-slot',
  PRODUCT_ROW = 'catalog-product-row',
  PRODUCT_ROW_DRAG_HANDLE = 'catalog-product-row-drag-handle',
  DROP_INDICATOR = 'catalog-drop-indicator',
  PRODUCT_ROW_SKELETON = 'catalog-product-row-skeleton',
  SECTION_HEADER = 'catalog-section-header',
  SECTION_HEADER_NAME = 'catalog-section-header-name',
  SECTION_HEADER_NAME_INPUT = 'catalog-section-header-name-input',
  SECTION_EMPTY_PLACEHOLDER = 'catalog-section-empty-placeholder',
  VIEW_BUTTON = 'catalog-view-button',
  VIEW_POPOVER = 'catalog-view-popover',
  VIEW_TABS = 'catalog-view-tabs',
  VIEW_TAB_LIST = 'catalog-view-tab-list',
  VIEW_TAB_CARD = 'catalog-view-tab-card',
  VIEW_GROUP_BY_SELECT = 'catalog-view-group-by-select',
  VIEW_SORT_BY_SELECT = 'catalog-view-sort-by-select',
  VIEW_CLASSIFICATION_TYPE_SELECT = 'catalog-view-classification-type-select',
  VIEW_GROUP_CLASSIFICATION_TYPE_SELECT = 'catalog-view-group-classification-type-select',
  VIEW_CARD_SIZE_SELECT = 'catalog-view-card-size-select',
  VIEW_RESTORE_BUTTON = 'catalog-view-restore-button',
  VIEW_APPLY_BUTTON = 'catalog-view-apply-button',
  VIEW_APPLY_MENU_BUTTON = 'catalog-view-apply-menu-button',
  VIEW_APPLY_FOR_ME_ITEM = 'catalog-view-apply-for-me-item',
  VIEW_APPLY_FOR_ALL_ITEM = 'catalog-view-apply-for-all-item',
  VIEW_MANUAL_ARRANGEMENT_CONFIRM = 'catalog-view-manual-arrangement-confirm',
  VIEW_FREEZE_ARRANGEMENT_CHOICE = 'catalog-view-freeze-arrangement-choice',
  VIEW_NOT_GROUPED_WARNING = 'catalog-view-not-grouped-warning',
}
